"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoyageAIEnvironment = void 0;
exports.VoyageAIEnvironment = {
    Default: "https://api.voyageai.com/v1",
};
